export default __webpack_public_path__ + "static/hero_personal_back_img_0-6c6bd274bdf91374d23a1d45935b6ab3.png";